import { BpkButtonV2 } from '@skyscanner/backpack-web/bpk-component-button';
import BpkText, {
  TEXT_COLORS,
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';

import PriceChangeReminder from './PriceChangeReminder';

import type { I18nService } from '@shared/types/i18n';
import type { Stay } from '@shared/types/utils';

import STYLES from './MainPrice.module.scss';

import {
  usePartnersOffersList,
  usePollingStatus,
} from '@hotels-hotel-detail/data-access/hooks/useHotelOffersContext';
import CenteredSpinner from '@shared/ui/components/CenteredSpinner';
import { withI18n } from '@shared/ui/contexts/i18n';
import { scrollToHotelPrices } from '@shared/utils-frontend/navigation-service';

type Props = {
  i18n: I18nService;
  stay: Stay;
  priceIndex: number;
};

const MainPrice = ({ i18n, priceIndex = 0, stay }: Props) => {
  const uBffIsLoading = !usePollingStatus();
  const partnersOffers = usePartnersOffersList();
  const flatOffers = partnersOffers.flatMap(
    (partnerOffers) => partnerOffers.offers,
  );

  if (uBffIsLoading) {
    return <CenteredSpinner className={STYLES.MainPrice} />;
  }

  const price = flatOffers[0]?.price.price;

  if (!price) {
    return null;
  }

  return (
    <div className={STYLES.MainPrice__wrapper}>
      <PriceChangeReminder price={price} stay={stay} priceIndex={priceIndex}>
        <BpkText
          textStyle={TEXT_STYLES.heading2}
          className={STYLES.MainPrice__price}
          color={TEXT_COLORS.textPrimary}
        >
          {i18n.formatCurrency(price)}
        </BpkText>
      </PriceChangeReminder>
      <BpkButtonV2
        data-test-id="main-price-sticky"
        className={STYLES.MainPrice__button}
        onClick={scrollToHotelPrices}
      >
        {i18n.translate('OTARates_button_viewDeals')}
      </BpkButtonV2>
    </div>
  );
};

export default withI18n(MainPrice);
